
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const NetMovementPage = lazy(() => import('./NetMovementPage'));
const path = 'reports/net-movement';
const NetMovementRoute: FuseRouteItemType = {
	path: path,
	element: <NetMovementPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Net Movement',
					helpName: 'Net Movement',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default NetMovementRoute;
